import React from 'react';
import './Footer.css';
import { navigateToHomeSection } from '../utils/navigation';

const Footer = () => {
  return (
    <footer className="footer">

      <div className="container">

        <div className="footer-top">

          {/* LEFT */}

          <div className="footer-brand">

            <img
  src="/images/icon.PNG"
  alt="AIVION"
  className="nav-logo-img"
/>

            <p>
              Delivering meaningful outcomes through intelligent AI solutions.
            </p>

            <div className="footer-social">

              <a
                href="https://www.linkedin.com/company/aivionai/posts/?feedView=all"
                target="_blank"
                rel="noreferrer"
              >
                <i className="fab fa-linkedin-in"></i>
              </a>

              <a
                href="mailto:info@aivion.ai"
              >
                <i className="far fa-envelope"></i>
              </a>

            </div>

          </div>

          {/* CENTER */}

          <div className="footer-column">

            <h4>QUICK LINKS</h4>

            <ul>

              <li><a href="/#services" onClick={(e)=>{e.preventDefault(); navigateToHomeSection('/#services');}}>Services</a></li>

              <li><a href="/#products" onClick={(e)=>{e.preventDefault(); navigateToHomeSection('/#products');}}>Products</a></li>

              <li><a href="/#industries" onClick={(e)=>{e.preventDefault(); navigateToHomeSection('/#industries');}}>Industries</a></li>

              <li><a href="/#clients" onClick={(e)=>{e.preventDefault(); navigateToHomeSection('/#clients');}}>Partners</a></li>

              <li><a href="/#about" onClick={(e)=>{e.preventDefault(); navigateToHomeSection('/#about');}}>About</a></li>

              <li><a href="/#how-we-work" onClick={(e)=>{e.preventDefault(); navigateToHomeSection('/#how-we-work');}}>How We Work</a></li>

              <li><a href="/#case-studies" onClick={(e)=>{e.preventDefault(); navigateToHomeSection('/#case-studies');}}>Case Studies</a></li>

              <li><a href="/#contact" onClick={(e)=>{e.preventDefault(); navigateToHomeSection('/#contact');}}>Contact Us</a></li>

            </ul>

          </div>

        </div>

        <div className="footer-divider"></div>

        <div className="footer-bottom">

          <p>
            © 2026 AIVION. All rights reserved.
          </p>

          

        </div>

      </div>

    </footer>
  );
};

export default Footer;
